module.exports = "/_next/static/images/mz-5a4a3d84c4b763ba4aa77e3861615eac.svg";